import { UserOutlined } from '@ant-design/icons';
import { Badge, Card, Descriptions, Tag, Typography } from 'antd';
import { getUserStatusBadgeConfig } from '../../../utils/userStatusConsts';

const { Text } = Typography;

interface UserInformationCardProps {
    userInfo: any;
    salaryDisplay: string;
    maxBalanceDisplay: string;
}

export const UserInformationCard = ({
    userInfo,
    salaryDisplay,
    maxBalanceDisplay,
}: UserInformationCardProps) => (
    <Card
        size="small"
        title={
            <span className="inline-flex items-center gap-2 font-medium">
                <UserOutlined className="text-blue-600" />
                User Information
            </span>
        }
        className="mb-5 rounded-lg shadow-sm"
    >
        <Descriptions
            bordered
            column={{ xs: 1, sm: 1, md: 1, lg: 2 }}
            size="small"
            className="[&_.ant-descriptions-item-label]:w-[26%] [&_.ant-descriptions-item-label]:bg-slate-50 [&_.ant-descriptions-item-label]:font-semibold [&_.ant-descriptions-item-content]:bg-white [&_.ant-descriptions-item-content]:font-medium"
        >
            <Descriptions.Item label="Full Name">
                {userInfo?.name || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
                <Text copyable={userInfo?.phone}>{userInfo?.phone || 'N/A'}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="User ID">
                <Text copyable={userInfo?.userID}>{userInfo?.userID || 'N/A'}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Company Name">
                {userInfo?.companyName || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Staff ID">
                {userInfo?.staff_id || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Status">
                {userInfo?.userStatusType ? (
                    <Badge
                        {...getUserStatusBadgeConfig(userInfo?.userStatusTypeID)}
                        text={userInfo.userStatusType}
                    />
                ) : (
                    'N/A'
                )}
            </Descriptions.Item>
            <Descriptions.Item label="Salary">
                <Tag color="blue">{salaryDisplay}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Maximum Balance">
                <Tag color="geekblue">{maxBalanceDisplay}</Tag>
            </Descriptions.Item>
        </Descriptions>
    </Card>
);
